"use strict";

ixModuleRouting("impactx.lobby", {
    "/lobby": {
        template: "<ixa-lobby></ixa-lobby>",
        templateUrl: "modules/lobby/templates/lobby.tmpl.html",
        controller: "LobbyCtrl as ctrl",
        process: "Any",
        workspace: "shop",
    },
});
